import { MongoObservable } from 'meteor-rxjs';
import { User } from '../models/user';

export const Users = MongoObservable.fromExisting(
  Meteor.users,
) as MongoObservable.Collection<User>;

Users.allow({
  insert: function () {
    return false;
  },
  update: function () {
    return false;
  },
  remove: function () {
    return false;
  },
});

if (Meteor.isServer) {
  Users.rawCollection().createIndex({ role: 1 });
  Users.rawCollection().createIndex({ customerId: 1 });
  Users.rawCollection().createIndex({ sendEnrollment: 1 });
  Users.rawCollection().createIndex({ _id: 1, isIntemp: 1 });
  // for msal login
  Users.rawCollection().createIndex({ 'services.msal.id': 1 });
}
